import * as Preact from 'preact';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useMediaQuery } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { getTheme } from './themes';
import * as ConfigCard from './A_ConfigProductCard';

/**
 * Figma design nodes:
 * Mobile: https://www.figma.com/file/va7snk88pL7TR7F75h7zbt/Design-Files?node-id=9687%3A59091
 * Desktop: https://www.figma.com/file/va7snk88pL7TR7F75h7zbt/Design-Files?node-id=9687%3A59096
 */

export type Props = { helperText: string };

const theme = getTheme();

/**
 * Used as a divider card in Config Card group, it shares the same height as the config card on mobile layout
 * but on desktop it takes up two columns and has a set height
 */

export const Component = (p: Props) => (
    <Box
        sx={{
            height: { xs: ConfigCard.cardHeight, md: '45px' },
            width: { xs: '142px', md: '100%' },
            backgroundColor: 'background.paper',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: { xs: 'space-between', md: 'center' },
            alignItems: 'flex-start',
            padding: '12px',
            paddingLeft: { md: '0px' },
            boxSizing: 'border-box',
            borderRadius: '8px',
            flexShrink: '0',
        }}
    >
        <Typography variant="h5">{p.helperText}</Typography>
        {useMediaQuery(theme.breakpoints.down('md')) && (
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
                <ArrowForwardIcon color="primary" />
            </Box>
        )}
    </Box>
);
